"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseQuery_1 = require("./BaseQuery");
var Query_1 = require("./Query");
var typeChecks_1 = require("../utils/typeChecks");
var ScenarioStatisticTarget_1 = require("../models/query/scenarioStatistics/ScenarioStatisticTarget");
var transform_1 = require("./transform");
var shortcuts = require("./scenarioStatistics/shortcuts");
var shortcuts_1 = require("../models/query/scenarioStatistics/shortcuts");
var ScenarioStatisticQuery = /** @class */ (function (_super) {
    __extends(ScenarioStatisticQuery, _super);
    function ScenarioStatisticQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.shortcuts = {
            entityRisksTable: new shortcuts.EntityRisksTableShortcut(_this),
            portfoliosMptStatistics: new shortcuts.PortfoliosMptStatisticsShortcut(_this),
            portfolios: new shortcuts.PortfoliosShortcut(_this),
            fund: new shortcuts.FundShortcut(_this),
            funds: new shortcuts.FundsShortcut(_this),
            portfolio: new shortcuts.PortfolioShortcut(_this),
            portfolioCompositeFund: new shortcuts.PortfolioCompositeFundShortcut(_this),
            portfolioCorrelation: new shortcuts.PortfolioCorrelationShortcut(_this),
            portfoliosBarChartData: new shortcuts.PortfoliosBarChartDataShortcut(_this),
            portfoliosScatterChartData: new shortcuts.PortfoliosScatterChartDataShortcut(_this),
        };
        _this.idEquals = function (idA, idB) {
            return idA === idB || (!typeChecks_1.isNullOrUndefined(idA) && !typeChecks_1.isNullOrUndefined(idB) && idA.toString() === idB.toString());
        };
        return _this;
    }
    ScenarioStatisticQuery.prototype.getOptions = function () {
        return this.queryOptions && ((this.queryOptions.options && this.queryOptions.options.scenarioStatistic) || this.queryOptions.scenarioStatisticOptions || {});
    };
    ScenarioStatisticQuery.prototype.getRawValue = function (executionOptions) {
        this.executionOptions = executionOptions;
        var response = this.getValueForRoot(this.statistics, this.scenarioStatisticOptions);
        return response;
    };
    ScenarioStatisticQuery.prototype.getValueForRoot = function (scenarioStatistics, rootOptions) {
        var response = scenarioStatistics;
        if (rootOptions && scenarioStatistics) {
            var key = rootOptions.key, _a = rootOptions.options, options = _a === void 0 ? {} : _a, shortcut = rootOptions.shortcut, transforms = rootOptions.transforms;
            if (shortcut) {
                response = this.getValueForShortcut(scenarioStatistics, shortcut);
            }
            else {
                switch (key) {
                    case 'periods':
                        response = this.getValueForPeriods(scenarioStatistics.periods, options[key]);
                        break;
                    default:
                        response = scenarioStatistics[key];
                        response = this.applyTransforms(response, transforms, this.queryOptions, this.executionOptions);
                        break;
                }
            }
        }
        return response;
    };
    ScenarioStatisticQuery.prototype.getValueForShortcut = function (scenarioStatistics, shortcutOptions) {
        var response = undefined;
        if (shortcutOptions) {
            var key = shortcutOptions.key;
            var shortcut = this.shortcuts[key];
            if (shortcut) {
                switch (shortcut.type) {
                    case shortcuts_1.ShortcutType.directResponse:
                        response = shortcut.getDirectResponse(shortcutOptions, scenarioStatistics);
                        break;
                    case shortcuts_1.ShortcutType.rootOptions:
                        var rootOptions = shortcut.getRootOptions(shortcutOptions);
                        response = this.getValueForRoot(scenarioStatistics, rootOptions);
                        break;
                }
            }
        }
        return response;
    };
    ScenarioStatisticQuery.prototype.getValueForPeriods = function (periods, periodOptions) {
        var _this = this;
        var response = periods;
        if (periodOptions) {
            var _a = periodOptions.target, target = _a === void 0 ? ScenarioStatisticTarget_1.ScenarioStatisticTarget.single : _a;
            if (target === ScenarioStatisticTarget_1.ScenarioStatisticTarget.single) {
                var singlePeriodType = this.getSinglePeriodType(periodOptions);
                var period = this.getPeriod(singlePeriodType);
                response = this.getValueForPeriod(period, periodOptions);
            }
            else if (target === ScenarioStatisticTarget_1.ScenarioStatisticTarget.collection) {
                response = this.getCollectionResponse(periods, function (item) { return _this.getValueForPeriod(item, periodOptions); }, function (item) { return item.periodType.toString(); }, periodOptions.collectionOptions);
            }
        }
        return response;
    };
    ScenarioStatisticQuery.prototype.applyValueTransform = function (value, valueTransform) {
        var response = value;
        if (valueTransform) {
            var prefix = valueTransform.prefix, suffix = valueTransform.suffix, staticValue = valueTransform.staticValue, transforms = valueTransform.transforms;
            if (!typeChecks_1.isNullOrUndefined(staticValue)) {
                response = staticValue;
            }
            if (transforms) {
                response = this.applyTransforms(response, transforms, this.queryOptions, this.executionOptions);
            }
            if (!typeChecks_1.isNullOrEmpty(prefix)) {
                response = "" + prefix + response;
            }
            if (!typeChecks_1.isNullOrEmpty(suffix)) {
                response = "" + response + suffix;
            }
        }
        return response;
    };
    ScenarioStatisticQuery.prototype.applyTransforms = function (value, transforms, queryOptions, executionOptions) {
        if (transforms) {
            for (var _i = 0, transforms_1 = transforms; _i < transforms_1.length; _i++) {
                var transformOptions = transforms_1[_i];
                var transform = new transform_1.Transform(transformOptions, this.translationHelper);
                value = transform.execute(value, queryOptions, executionOptions);
            }
        }
        return value;
    };
    ScenarioStatisticQuery.prototype.getCollectionResponse = function (collection, getItem, getId, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        var pivotToObject = options.pivotToObject, injectId = options.injectId;
        if (pivotToObject && pivotToObject.enabled) {
            var _a = pivotToObject.transform, transform = _a === void 0 ? {} : _a;
            var keyTransform_1 = transform.key, valueTransform_1 = transform.value;
            return collection.reduce(function (acc, item) {
                var itemResponse = getItem(item);
                var rawId = getId(item);
                if (!typeChecks_1.isNullOrUndefined(rawId)) {
                    var id = _this.applyValueTransform(rawId, keyTransform_1);
                    acc[id] = _this.applyValueTransform(itemResponse, valueTransform_1);
                }
                return acc;
            }, {});
        }
        if (injectId && injectId.enabled) {
            var _b = injectId.transform, transform = _b === void 0 ? {} : _b;
            var keyTransform_2 = transform.key, valueTransform_2 = transform.value;
            return collection.map(function (item) {
                var _a, _b;
                var itemResponse = getItem(item);
                var rawId = getId(item);
                if (!typeChecks_1.isNullOrUndefined(rawId)) {
                    var id = _this.applyValueTransform(rawId, valueTransform_2);
                    var key = _this.applyValueTransform('id', keyTransform_2);
                    if (Array.isArray(itemResponse)) {
                        return _a = {}, _a[key] = id, _a.values = itemResponse, _a;
                    }
                    if (typeChecks_1.isObject(itemResponse)) {
                        return __assign((_b = {}, _b[key] = id, _b), itemResponse);
                    }
                }
                return itemResponse;
            });
        }
        return collection.map(function (item) {
            var itemResponse = getItem(item);
            return itemResponse;
        });
    };
    ScenarioStatisticQuery.prototype.getValueForPeriod = function (period, periodOptions) {
        var response = period;
        if (!period) {
            return undefined;
        }
        var key = periodOptions.key, _a = periodOptions.options, options = _a === void 0 ? {} : _a, excludeBenchmarkFromPortfolios = periodOptions.excludeBenchmarkFromPortfolios, transforms = periodOptions.transforms;
        if (key) {
            switch (key) {
                case 'dates':
                    response = this.getValueForDates(period[key], options[key]);
                    break;
                case 'benchmark':
                    response = this.getValueForBenchmark(period[key], options[key]);
                    break;
                case 'portfolios':
                    var portfolios = __spreadArrays((period.portfolios || []));
                    if (!excludeBenchmarkFromPortfolios && period.benchmark) {
                        portfolios.push(period.benchmark);
                    }
                    response = this.getValueForPortfolios(portfolios, options[key]);
                    break;
                case 'entityRisks':
                    response = this.getValueForEntityRisks(period[key], options[key]);
                    break;
                default:
                    response = period[key];
                    break;
            }
        }
        response = this.applyTransforms(response, transforms, this.queryOptions, this.executionOptions);
        return response;
    };
    ScenarioStatisticQuery.prototype.getValueForDates = function (dates, datesOptions) {
        var response = undefined;
        if (!dates) {
            return undefined;
        }
        var key = datesOptions.key, _a = datesOptions.options, options = _a === void 0 ? {} : _a, transforms = datesOptions.transforms;
        switch (key) {
            case 'commonDates':
            case 'allDates':
                response = this.getValueForArray(dates[key], options[key]);
                break;
            default:
                response = dates[key];
                break;
        }
        response = this.applyTransforms(response, transforms, this.queryOptions, this.executionOptions);
        return response;
    };
    ScenarioStatisticQuery.prototype.getValueForEntityRisks = function (entityRisks, entityRiskOptions) {
        var response = entityRisks;
        if (!entityRisks) {
            return undefined;
        }
        return response;
    };
    ScenarioStatisticQuery.prototype.getValueForBenchmark = function (benchmark, benchmarkOptions) {
        return this.getValueForPortfolioBase(benchmark, benchmarkOptions);
    };
    ScenarioStatisticQuery.prototype.getValueForPortfolioBase = function (portfolioResult, portfolioBaseOptions) {
        var response = undefined;
        if (!portfolioResult) {
            return undefined;
        }
        var key = portfolioBaseOptions.key, _a = portfolioBaseOptions.options, options = _a === void 0 ? {} : _a, transforms = portfolioBaseOptions.transforms;
        switch (key) {
            case 'funds':
                response = this.getValueForEntities(portfolioResult[key], options[key]);
                break;
            case 'portfolio':
                response = this.getValueForPortfolio(portfolioResult[key], options[key]);
                break;
            default:
                response = portfolioResult[key];
                break;
        }
        response = this.applyTransforms(response, transforms, this.queryOptions, this.executionOptions);
        return response;
    };
    ScenarioStatisticQuery.prototype.getValueForPortfolios = function (portfolios, portfolioOptions) {
        var _this = this;
        var response = portfolios;
        var _a = (portfolioOptions || {}).target, target = _a === void 0 ? ScenarioStatisticTarget_1.ScenarioStatisticTarget.single : _a;
        if (target === ScenarioStatisticTarget_1.ScenarioStatisticTarget.single) {
            var singlePortfolioId = this.getSinglePortfolioId(portfolioOptions);
            var portfolio = this.getPortfolio(portfolios, singlePortfolioId);
            response = this.getValueForPortfolioBase(portfolio, portfolioOptions);
        }
        else if (target === ScenarioStatisticTarget_1.ScenarioStatisticTarget.collection) {
            response = this.getCollectionResponse(portfolios, function (item) { return _this.getValueForPortfolioBase(item, portfolioOptions); }, function (item) { return item.id && item.id.toString(); }, portfolioOptions.collectionOptions);
        }
        return response;
    };
    ScenarioStatisticQuery.prototype.getValueForPortfolio = function (portfolio, portfolioOptions) {
        var response = undefined;
        var _a = portfolioOptions || {}, key = _a.key, _b = _a.options, options = _b === void 0 ? {} : _b, transforms = _a.transforms;
        switch (key) {
            case 'MCTR':
            case 'absCTR':
            case 'correlation':
            case 'covariance':
            case 'RSquared':
            case 'excessReturnsCorrelation':
                response = this.getValueForAssetMatrix(portfolio[key], options[key]);
                break;
            case 'trailingReturns':
            case 'forecast':
                response = this.getValueForObjectArray(portfolio[key], options[key]);
                break;
            case 'error':
                response = this.getValueForArray(portfolio[key], options[key]);
                break;
            case 'compositeFund':
                response = this.getValueForEntity(portfolio[key], options[key]);
                break;
            default:
                response = portfolio[key];
                break;
        }
        response = this.applyTransforms(response, transforms, this.queryOptions, this.executionOptions);
        return response;
    };
    ScenarioStatisticQuery.prototype.getValueForDrawdown = function (drawdown, drawdownOptions) {
        var response = undefined;
        var _a = drawdownOptions || {}, key = _a.key, _b = _a.options, options = _b === void 0 ? {} : _b, transforms = _a.transforms;
        switch (key) {
            case 'drawdownSeries':
                response = this.getValueForObjectArray(drawdown[key], options[key]);
                break;
            default:
                response = drawdown[key];
                break;
        }
        response = this.applyTransforms(response, transforms, this.queryOptions, this.executionOptions);
        return response;
    };
    ScenarioStatisticQuery.prototype.getValueForEntities = function (entities, entityOptions) {
        var _this = this;
        var response = entities;
        var _a = (entityOptions || {}).target, target = _a === void 0 ? ScenarioStatisticTarget_1.ScenarioStatisticTarget.single : _a;
        if (target === ScenarioStatisticTarget_1.ScenarioStatisticTarget.single) {
            var singlePortfolioEntityId = this.getSinglePortfolioEntityId(entityOptions);
            var entity = this.getFund(entities, singlePortfolioEntityId);
            response = this.getValueForEntity(entity, entityOptions);
        }
        else if (target === ScenarioStatisticTarget_1.ScenarioStatisticTarget.collection) {
            response = this.getCollectionResponse(entities, function (item) { return _this.getValueForEntity(item, entityOptions); }, function (item) { return item.name && item.name.toString(); }, entityOptions.collectionOptions);
        }
        return response;
    };
    ScenarioStatisticQuery.prototype.getValueForEntity = function (entity, entityOptions) {
        var response = entity;
        if (entityOptions && entity) {
            var key = entityOptions.key, _a = entityOptions.options, options = _a === void 0 ? {} : _a, transforms = entityOptions.transforms;
            if (key) {
                switch (key) {
                    case 'bestPeriod':
                    case 'worstPeriod':
                    case 'calendarYearReturns':
                    case 'excessReturns':
                    case 'excessReturnsOverRF':
                    case 'trailingYearReturns':
                    case 'trailingQuarterReturnsCumulative':
                    case 'trailingQuarterReturns':
                    case 'trailingVolatilityPop':
                    case 'trailingVolatilitySam':
                    case 'longestPosPeriod':
                    case 'longestNegPeriod':
                    case 'riskFreeReturns':
                    case 'rollingAverage':
                    case 'seriesSplice':
                        response = this.getValueForObjectArray(entity[key], options[key]);
                        break;
                    case 'drawdown2':
                    case 'drawdown2Benchmark':
                    case 'drawdown2RF':
                        response = this.getValueForDrawdown(entity[key], options[key]);
                        break;
                    case 'error':
                        response = this.getValueForArray(entity[key], options[key]);
                        break;
                    default:
                        response = entity[key];
                        break;
                }
            }
            response = this.applyTransforms(response, transforms, this.queryOptions, this.executionOptions);
        }
        return response;
    };
    ScenarioStatisticQuery.prototype.getValueForAssetMatrix = function (assetMatrix, options) {
        var response = assetMatrix;
        if (assetMatrix && options) {
            var matrix = assetMatrix.matrix, portfolioNames = assetMatrix.portfolioNames;
            if (matrix && portfolioNames && matrix.length === portfolioNames.length) {
                if (options.pivotToTableData) {
                    var _a = options.excludeAboveTheFoldValues, excludeAboveTheFoldValues = _a === void 0 ? false : _a;
                    var rows = [];
                    var columns = [];
                    for (var outerIndex = 0; outerIndex < portfolioNames.length; outerIndex++) {
                        var portfolioName = portfolioNames[outerIndex];
                        var matrixRow = matrix[outerIndex];
                        var row = {
                            index: outerIndex + 1,
                            id: portfolioName,
                        };
                        for (var innerIndex = 0; innerIndex < portfolioNames.length; innerIndex++) {
                            if (excludeAboveTheFoldValues && innerIndex > outerIndex) {
                                break;
                            }
                            var columnKey = portfolioNames[innerIndex];
                            row[columnKey] = matrixRow.length === portfolioNames.length ? matrixRow[innerIndex] : undefined;
                            if (columns.length < innerIndex + 1) {
                                columns.push({
                                    key: columnKey,
                                    header: "" + (innerIndex + 1),
                                });
                            }
                        }
                        rows.push(row);
                    }
                    response = {
                        rows: rows,
                        columns: columns,
                    };
                }
                else if (options.matrix || options.percentMatrix) {
                    var target = options.matrix;
                    var targetKey = 'matrix';
                    if (options.percentMatrix) {
                        target = options.percentMatrix;
                        targetKey = 'percentMatrix';
                    }
                    var _b = target.subIndex, subIndex = _b === void 0 ? 0 : _b;
                    var portfolioNameQuery = new Query_1.Query(target.portfolioName, this.translationHelper);
                    var targetPortfolioName_1 = portfolioNameQuery.execute(this.executionOptions);
                    var index = assetMatrix.portfolioNames.findIndex(function (portfolioName) { return portfolioName === targetPortfolioName_1; });
                    if (assetMatrix[targetKey] && assetMatrix[targetKey].length > index && assetMatrix[targetKey][index] && assetMatrix[targetKey][index].length > 0) {
                        response = assetMatrix[targetKey][index][subIndex];
                    }
                    else {
                        response = 0;
                    }
                }
            }
        }
        return response;
    };
    ScenarioStatisticQuery.prototype.getValueForObjectArray = function (arr, options) {
        var response = arr;
        if (options && Array.isArray(arr)) {
            var index = options.index, startIndex = options.startIndex;
            if (!typeChecks_1.isNullOrUndefined(index) && arr.length > index) {
                response = arr[index];
                if (!typeChecks_1.isNullOrUndefined(options.key) && typeof response === 'object') {
                    response = response[options.key];
                }
            }
            else if (!typeChecks_1.isNullOrUndefined(startIndex)) {
                if (startIndex >= 0) {
                    response = arr.slice(startIndex);
                }
                if (startIndex < 0) {
                    response = arr.slice(Math.max(arr.length + startIndex, 0));
                }
            }
        }
        return response;
    };
    ScenarioStatisticQuery.prototype.getValueForArray = function (arr, options) {
        var response = arr;
        if (options && Array.isArray(arr) && !typeChecks_1.isNullOrUndefined(options.index) && arr.length > options.index) {
            response = arr[options.index];
        }
        return response;
    };
    Object.defineProperty(ScenarioStatisticQuery.prototype, "scenarioStatisticOptions", {
        get: function () {
            return this.options;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScenarioStatisticQuery.prototype, "inputs", {
        get: function () {
            return (this.executionOptions && this.executionOptions.inputs) || {};
        },
        enumerable: true,
        configurable: true
    });
    ScenarioStatisticQuery.prototype.getSinglePeriodType = function (periodOptions) {
        if (periodOptions === void 0) { periodOptions = {}; }
        if (!this.rawPeriodType && periodOptions) {
            if (periodOptions.type) {
                this.rawPeriodType = periodOptions.type;
            }
            else if (this.inputs['periodType']) {
                var inputPeriodType = this.inputs['periodType'];
                var parsedValue = parseInt(inputPeriodType, 10);
                this.rawPeriodType = (Number.isNaN(parsedValue) ? 'all' : parsedValue);
            }
        }
        return this.rawPeriodType;
    };
    ScenarioStatisticQuery.prototype.getSinglePortfolioId = function (options) {
        if (options === void 0) { options = {}; }
        if (!this.rawPortfolioId && options) {
            if (options.id) {
                this.rawPortfolioId = options.id.toString();
            }
            else if (options.idQuery) {
                var portfolioIdQuery = new Query_1.Query(options.idQuery, this.translationHelper);
                this.rawPortfolioId = portfolioIdQuery.execute(this.executionOptions);
            }
            else if (this.inputs['portfolioId']) {
                this.rawPortfolioId = this.inputs['portfolioId'].toString();
            }
        }
        return this.rawPortfolioId;
    };
    ScenarioStatisticQuery.prototype.getSinglePortfolioEntityId = function (options) {
        if (options === void 0) { options = {}; }
        if (!this.rawPortfolioEntityId && options) {
            if (options.id) {
                this.rawPortfolioEntityId = options.id.toString();
            }
            else if (options.idQuery) {
                var portfolioEntityIdQuery = new Query_1.Query(options.idQuery, this.translationHelper);
                this.rawPortfolioEntityId = portfolioEntityIdQuery.execute(this.executionOptions);
            }
            else if (this.inputs['portfolioEntityId']) {
                this.rawPortfolioEntityId = this.inputs['portfolioEntityId'].toString();
            }
        }
        return this.rawPortfolioEntityId;
    };
    ScenarioStatisticQuery.prototype.getPeriod = function (periodType) {
        if (this.statistics && periodType && this.statistics.periods) {
            return this.statistics.periods.find(function (period) { return period.periodType === periodType; });
        }
    };
    ScenarioStatisticQuery.prototype.getPortfolioStatisticResult = function (period, portfolioId) {
        var _this = this;
        var response;
        if (period && portfolioId) {
            response = period.portfolios.find(function (portfolio) { return _this.idEquals(portfolio.id, portfolioId); });
            if (!response && this.idEquals(period.benchmark.id, portfolioId)) {
                response = period.benchmark;
            }
        }
        return response;
    };
    ScenarioStatisticQuery.prototype.getFund = function (funds, portfolioEntityId) {
        var _this = this;
        if (funds && portfolioEntityId) {
            return funds.find(function (fund) { return _this.idEquals(fund.name, portfolioEntityId); });
        }
        return undefined;
    };
    ScenarioStatisticQuery.prototype.getPortfolio = function (portfolios, portfolioId) {
        var _this = this;
        if (portfolios && portfolioId) {
            var portfolio = portfolios.find(function (portfolio) { return _this.idEquals(portfolio.id, portfolioId); });
            return portfolio;
        }
        return undefined;
    };
    ScenarioStatisticQuery.prototype.getDates = function (period) {
        return period && period.dates;
    };
    Object.defineProperty(ScenarioStatisticQuery.prototype, "context", {
        get: function () {
            return Query_1.Query.getContext(this.executionOptions, this.queryOptions);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScenarioStatisticQuery.prototype, "statistics", {
        get: function () {
            return (this.context && this.context.scenarioStatistics);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScenarioStatisticQuery.prototype, "scenario", {
        get: function () {
            return (this.context && this.context.scenario);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScenarioStatisticQuery.prototype, "portfolio", {
        get: function () {
            return (this.context && this.context.portfolio);
        },
        enumerable: true,
        configurable: true
    });
    return ScenarioStatisticQuery;
}(BaseQuery_1.BaseQuery));
exports.ScenarioStatisticQuery = ScenarioStatisticQuery;
//# sourceMappingURL=ScenarioStatisticQuery.js.map